var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusCircleWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    transform: "rotate(-90 12 12)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.335 11.381h-3.716V7.666a.62.62 0 00-1.238 0v3.715H7.666a.619.619 0 100 1.239h3.715v3.715a.62.62 0 001.238 0V12.62h3.716a.62.62 0 000-1.239z",
    fill: "#2355FC",
    stroke: "#2355FC",
    strokeWidth: 0.6
  })));
}

export default SvgPlusCircleWhite;